// extracted by mini-css-extract-plugin
export var container = "training-video-module--container--XBtvg";
export var newContainer = "training-video-module--newContainer--wahbi";
export var play = "training-video-module--play--BcPQ2";
export var titleContainer = "training-video-module--titleContainer--Bn6Ea";